export const HideNavigation = ["/login", "/get-started", "/login-legacy", "/forgot-pin"]
